var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",staticStyle:{"object-fit":"cover"},attrs:{"autoplay":"","playsinline":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }